const TABLE_TYPE = "wix-rich-content-plugin-table";
const INSERT_TABLE_MODAL_ID = "TABLE.insert";
export {
  INSERT_TABLE_MODAL_ID,
  TABLE_TYPE
};
//# sourceMappingURL=types.js.map
